import Button from './Button'
import React from 'react'
import classNames from 'classnames'

export default function ValidationBanner(props: {
  onDetails?: () => void
  children: React.ReactNode
  top?: string
  bottom?: string
}) {
  const { top, bottom, children, onDetails } = props
  return (
    <div
      className="validation-banner-outer"
      style={{
        top, bottom
      }}
    >
      <div className="validation-banner">
        <div className={classNames('description', { left: !!onDetails })}>
          {children}
        </div>
        {
          onDetails && (
            <Button buttonStyle="whiteStroke" flat onClick={onDetails}>
              More info
            </Button>
          )
        }
      </div>
    </div>
  )
}
